// @flow

import { all, put, takeEvery, delay } from 'redux-saga/effects';
import * as Sentry from '@sentry/browser';
// import ReactGA from 'react-ga4';
import mixpanel from 'mixpanel-browser';
import { getProfileActions } from '../actions/profile';
import { getNotificationListActions } from '../actions/notifications';
import { idempotentStartWebsocketService } from '../websocketService';
import { getBuildListActions } from '../actions/builds';
import { getUserActions } from '../actions/user';
import * as types from '../actionTypes';
import { HitchpinApi } from '../../api/Hitchpin';

function* launchAllAuthedDataFetches() {
  if (window.localStorage && window.localStorage.getItem('token')) {
    yield put(getUserActions.ifNeeded());
    yield put(getProfileActions.ifNeeded());

    HitchpinApi.auth.get().then(res => {
      const user = res.body;
      mixpanel.identify(user.id);
      mixpanel.people.set({ last_login_date: new Date().toISOString() });
      mixpanel.register({
        app_version: `HitchPin Web ${
          process.env.REACT_APP_VERSION ||
          process.env.REACT_APP_COMMIT_HASH ||
          'development'
        }`,
      });
    });

    yield delay(1000);
    idempotentStartWebsocketService();
  }
  yield put(getBuildListActions.ifNeeded());
  if (window.localStorage && window.localStorage.getItem('token')) {
    yield delay(1000);
    yield put(getNotificationListActions.ifNeeded());
  }
  HitchpinApi.clientVersion.postAppVersion();
}

function tagSentryScopeWithUserId(action) {
  const { id } = action;

  if (Sentry) {
    Sentry.configureScope(scope => {
      scope.setUser({ id });
    });
  }

  if (window.heap) {
    window.heap.identify(id);
  }
}

export default function* (): Generator<any, void, any> {
  yield all([
    takeEvery(types.INIT, launchAllAuthedDataFetches),
    takeEvery(types.LOG_IN, launchAllAuthedDataFetches),
    takeEvery(
      types.GET_PROFILE_ASYNC.SINGLETON.SUCCESS,
      tagSentryScopeWithUserId,
    ),
  ]);
}
